import { useDispatch, useSelector } from "react-redux";
import Autocomplete from "@mui/material/Autocomplete";
import { TextField, CircularProgress } from "@mui/material";
import { useEffect, forwardRef, Fragment } from "react";
import { styled } from "@mui/system";
import { Patient } from "../../app/slices/patientSlice";
import { useState } from "react";

export const SelectPatient = forwardRef((props, ref) => {
  const dispatch = useDispatch();

  const _Patient = useSelector((state) => state.patient.patients);
  const loading = useSelector((state) => state.patient.loading);

  const [searchPatient, setSearchPatient] = useState(props.search ?? "");

  useEffect(() => {
    const timeout = setTimeout(() => {
      dispatch(
        Patient.getAll({
          take: 20,
          search: searchPatient || "",
        })
      );
    }, 500);
    return () => clearTimeout(timeout);
  }, [dispatch, searchPatient]);

  const GroupHeader = styled("div")(({ theme }) => ({
    position: "sticky",
    top: "-8px",
    padding: "4px 10px",
    borderBottom: "1px solid #e0e0e0",
    color: "white",
    backgroundColor: theme.palette.primary.main,
  }));
  const GroupItems = styled("ul")({
    padding: 0,
  });

  return (
    <Autocomplete
      dir="rtl"
      ref={ref}
      options={_Patient.data || []}
      {...props}
      getOptionLabel={(option) => `${option.full_name} - ${option.mobile_1}`}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      onInputChange={(event, newInputValue) => {
        if (newInputValue === "") {
          setSearchPatient("");
        }
      }}
      renderInput={(params) => (
        <TextField
          onChange={(e) => {
            setSearchPatient(e.target.value);
          }}
          required={props.required}
          {...params}
          label="اسم المراجع"
          size="small"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <Fragment>
                {loading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </Fragment>
            ),
          }}
        />
      )}
      renderGroup={(params, key) => (
        <li key={params.key}>
          <GroupHeader>{params.group}</GroupHeader>
          <GroupItems>{params.children}</GroupItems>
        </li>
      )}
    />
  );
});
